import { render, staticRenderFns } from "./EditBetRowToto.vue?vue&type=template&id=a5d5fa88&scoped=true"
import script from "./EditBetRowToto.vue?vue&type=script&lang=js"
export * from "./EditBetRowToto.vue?vue&type=script&lang=js"
import style0 from "./EditBetRowToto.vue?vue&type=style&index=0&id=a5d5fa88&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5d5fa88",
  null
  
)

export default component.exports